




























import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { Getter, Mutation, Action } from 'vuex-class';
import Header from '@/components/Header.vue';


@Component({
  components: {
    Header,
  },
})
export default class ESignDisclosures extends Vue {
  @Getter('eSign') eSign!: boolean;

}
